import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ReportsService } from "../services/reports.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
@Component({
    selector: "app-portfolio-difference",
    templateUrl: "./portfolio-difference.component.html",
    styleUrls: ["./portfolio-difference.component.scss"],
    standalone: false
})
export class PortfolioDifferenceComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  JsonData: any;
  dataSource: MatTableDataSource<any>;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  searchType: any = "Stock";
  searchDate: any = "";

  displayedColumns: string[] = [
    "Id",
    "LoanAcNo",
    "Loan_Date",
    "Application_LTV",
    "Application_AgreementValue",
    "ExpiryDate",
    "CustomerName",
    "Gender",
    "Branch_Name",
    "Product_name",
    "Loan_Acc_Category",
    "Application_Case_IRR",
    "Application_LoanTenure",
    "EMIAmount",
    "PlanBalance",
    "VoucherBalance",
    "DifferenceBalance",
    "Closing",
    "AccountId",
    "Account_Name",
    "CorrectAccountId",
    "CorrectAccountName",
  ];

  // Add ViewChild for MatSort
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Portfolio Difference");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }
  GetReportPortfolioDifference() {
    this.showSpinner = true;
    this.reportsService
      .Report_ByPlan_ByVoucher_ByAccount({
        AsOnDate: this.searchDate,
        Type: this.searchType,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res && res.length > 0) {
          this.JsonData = res;
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.showSpinner = false;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
        }
      });
  }
ResetField() {{
    this.dataSource = null;
  }
}
  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode("month");
  }
  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "exposure_portfolio_difference"
    ) as HTMLTableElement;
    const worksheetName = "PORTFOLIO DIFFERENCE"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
    applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
